import { render, staticRenderFns } from "./search-chips.vue?vue&type=template&id=76b18400"
import script from "./search-chips.vue?vue&type=script&lang=js"
export * from "./search-chips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VCurrency: require('/var/www/tubber-new/components/global/v/currency.vue').default})
